<div class="filter-pills-skeleton">
  <div class="filter-pill-skeleton first"></div>
  <div class="filter-pill-skeleton"></div>
  <div class="filter-pill-skeleton"></div>
  <div class="filter-pill-skeleton"></div>
  <div class="filter-pill-skeleton"></div>
  <div class="filter-pill-skeleton"></div>
  <div class="filter-pill-skeleton"></div>
  <div class="filter-pill-skeleton"></div>
</div>
